import React from 'react';
import { Divider } from 'semantic-ui-react';

export const CartStep = ({ cart, totals }) => (
    <div>
        <h4>Položky:</h4>
        {cart.items.map((it) => (
            <div key={it.id} style={{ padding: '8px 0' }}>
                <div style={{ fontWeight: 'bold' }}>{it.name}</div>
                <ul>
                    {it.description.map((desc, i) => (
                        <li key={i}>{desc}</li>
                    ))}
                </ul>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>Množstvo: {it.qty}×</div>
                    <div>{(it.price * it.qty).toFixed(2)} €</div>
                </div>
            </div>
        ))}
        <Divider />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>Medzisúčet</div>
            <div>{totals.subtotal.toFixed(2)} €</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>Doprava</div>
            <div>{totals.shippingFee.toFixed(2)} €</div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>DPH (23%)</div>
            <div>{totals.vat.toFixed(2)} €</div>
        </div>
        <Divider />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700 }}>
            <div>Celkom</div>
            <div>{totals.total.toFixed(2)} €</div>
        </div>
    </div>
);